export const defaultAnnual = 0;
export const defaultDepartments = 0;
export const defaultParticipants = 0;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30RPAROI = '30AKY';
